import React from "react";
import { formatShortMonth, useUiLanguage } from "../utils/newsDates";

/** Small calendar tile of an event: the month over the day of the month. */
export function EventDateBadge({ startsAt }: { startsAt: number }) {
  const language = useUiLanguage();

  return (
    <div className="flex h-12 w-14 flex-shrink-0 flex-col items-center justify-center rounded-lg bg-blue-50 text-blue-700">
      <span className="text-[10px] font-semibold leading-none">{formatShortMonth(startsAt, language)}</span>
      <span className="text-lg font-bold leading-tight">{new Date(startsAt).getDate()}</span>
    </div>
  );
}
